<template>
      <div class="succesfull-order">
              <h3>{{_T('Thank you for your order')}}!</h3>
              <h5>{{_T('Your packed has been succesfully delivered')}}</h5>
            </div>
</template>

<script>
import { mapGetters } from 'vuex'
export default {
computed:{
  ...mapGetters(['_T'])
}
}
</script>

<style lang="scss" scoped>
    h3 {
      font-weight: bold;
      padding-top: calc(#{$px12} + (22 - 12) * ((100vw - #{$px320}) / (1920 - 320)));
      margin-bottom: calc(0px + (14 - 0) * ((100vw - #{$px320}) / (1920 - 320)));
    }
    h5 {
      letter-spacing: 0.005em;
      margin-bottom: calc(#{$px8} + (15 - 8) * ((100vw - #{$px320}) / (1920 - 320)));
    }
</style>